import { Injectable } from '@angular/core';
import { ParentRecordPrimaryKeyValuesModel } from '../models/parent-record-primary-key-values.model';
import { DataModel } from '@shared';
import { WorkspaceDatabaseKeys } from '@database/workspace';

@Injectable()
export class PrimaryKeyService {
	public constructor() {}

	public parentChildrensRecords(
		tablePrimaryKeys: string[],
		parentRecord: DataModel
	): ParentRecordPrimaryKeyValuesModel {
		// "primaryKeyAndValues": [{"primaryKey": "hole_number", "primaryKeyValue": "DM_2017-Demo-test"}],
		// "projectNumberKey": "project_number", "projectNumberValue": "DM_2017"}]
		return {
			primaryKeyAndValues: tablePrimaryKeys.map((primaryKey: string) => ({
				primaryKey,
				primaryKeyValue: parentRecord[primaryKey]
			})),
			projectNumberKey: WorkspaceDatabaseKeys.columns.projectNumber,
			projectNumberValue: parentRecord[WorkspaceDatabaseKeys.columns.projectNumber]
		};
	}
}
